import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { catchError, firstValueFrom, Observable, of, switchMap } from 'rxjs';
import { CommonService } from 'src/app/services/common/common.service';
import { CoreService } from 'src/app/services/core/core.service';
@Injectable({
  providedIn: 'root'
})
export class FileClaimGuard implements CanActivate {
  /**
   * constructor
   * @param coreService
   * @param router
   * @param route
   */
  constructor(private coreService: CoreService, private readonly router: Router, private commonService: CommonService) {}

  /**
   * canActivate
   * @returns
   */
  canActivate(next: ActivatedRouteSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.getExternalToken(next);
  }

  /**
   * checkUserPermission
   * @returns
   */
  getExternalToken(route: ActivatedRouteSnapshot): any {
    const source = route.params['source'];
    if (source) {
      try {
        const decodedString = atob(source);
        const sourceObj = JSON.parse(decodedString);
        return this.coreService.getExternalToken(sourceObj.source).pipe(
          switchMap(async (res) => {
            if (res) {
              const token = { idToken: res?.data.accessToken };
              localStorage.setItem('XAExternalSource', sourceObj.source);
              localStorage.setItem('XAuserDetails', JSON.stringify(token));
              localStorage.setItem('XAuserDetailsExternal', JSON.stringify(token));
              const org = await firstValueFrom(this.coreService.getOrgDetail());
              if (org) {
                this.commonService.orgDetail = {
                  ...org.data,
                  source: sourceObj.source
                };
              }
              if (sourceObj.primaryColor) {
                document.documentElement.style.setProperty('--xa-primary', sourceObj.primaryColor);
                const metaElement: HTMLMetaElement | null = document.querySelector('[name="theme-color"]');
                if (metaElement) {
                  metaElement.content = sourceObj.primaryColor;
                }
              }
              if (sourceObj.secondaryColor) {
                document.documentElement.style.setProperty('--xa-secondary', sourceObj.secondaryColor);
              }
              return of(true);
            } else {
              this.router.navigate([ 'error/404' ]);
              return of(false);
            }
          }),
          catchError(() => {
            this.router.navigate([ 'error/404' ]);
            return of(false);
          })
        );
      } catch (error) {
        this.router.navigate([ 'error/404' ]);
        return of(false);
      }
    } else {
      this.router.navigate([ 'error/404' ]);
      return of(false);
    }
  }
}
